function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.41421
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,10,5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.995,0.022L6.608,0.022C6.608,0.022 2.543,-0.478 2.543,4.486L2.543,7.442L0.035,7.442L0.003,11.176L2.495,11.176L2.495,20.009L6.366,20.009L6.366,11.176L8.927,11.176L9.549,7.392L6.366,7.392L6.366,4.955C6.366,4.955 6.095,3.612 7.669,3.612L9.966,3.612L9.995,0.022Z",
    style: {
      fill: "white"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.cd8e5874bda120193014c666eae30619.svg";
export { ForwardRef as ReactComponent };